import React, { Component } from 'react';
import { ToastContainer,toast,  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
import { Button, Badge } from 'reactstrap';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Viventium extends Component{

    constructor(props){
        super(props);
        this.state = {

            APIName: "viventium",
            APIUser: "",
            APIPass: "",
            ClientAPIUser: "",
            ClientAPIPass: "",
            CompanyCode: "",
            Division: "",
            loadingViventium: false,
            type: 'password',
            APIPasswordType: 'password',
            isAutenticated: true

        };
        this.handleApiUser = this.handleApiUser.bind(this);
        this.handleApiPass = this.handleApiPass.bind(this);
        this.handleClientApiUser = this.handleClientApiUser.bind(this);
        this.handleClientApiPass = this.handleClientApiPass.bind(this);
        this.handleCompanyCode = this.handleCompanyCode.bind(this);
        this.handleDivision = this.handleDivision.bind(this);
        this.showHide = this.showHide.bind(this);
        this.showHideAPIPasswordType = this.showHideAPIPasswordType.bind(this);
    }  

    showHide(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          type: this.state.type === 'input' ? 'password' : 'input'
        })  
    }
      showHideAPIPasswordType(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          APIPasswordType: this.state.APIPasswordType === 'input' ? 'password' : 'input'
        })  
    }

    componentDidMount(){

        var CompanyCodeSplit = "";
        var DivisionSplit = "";
        var ViventiumList = this.props.DataVivemtium;
        var viventium = ViventiumList.find(x=> x.ALIAS === this.state.APIName);  
        var viventiumValue = JSON.parse(viventium.VALUE);
        if(viventiumValue.CompanyCode !== null)
        {
            var temp =  viventiumValue.CompanyCode.split("-", 2);
            CompanyCodeSplit = temp[0];
            DivisionSplit = temp[1];
        }
        
        var UserName = viventiumValue.UserName === null || viventiumValue.UserName === undefined   ? "" :  viventiumValue.UserName;
        var Pass = viventiumValue.Password === null || viventiumValue.Password === undefined   ? "" :  viventiumValue.Password;
        var CompanyCode = viventium.COMPANY_CODE === null || viventium.COMPANY_CODE === undefined   ? "" :  CompanyCodeSplit;
        var Division = viventium.COMPANY_CODE === null || viventium.COMPANY_CODE === undefined   ? "" :  DivisionSplit;
        var EasyApiUser = viventiumValue.EasyApiUser === null || viventiumValue.EasyApiUser === undefined   ? "" :  viventiumValue.EasyApiUser;
        var EasyApiPassword = viventiumValue.EasyApiPassword === null || viventiumValue.EasyApiPassword === undefined   ? "" :  viventiumValue.EasyApiPassword;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = EasyApiUser;
        stateCopy.APIPass = EasyApiPassword;
        stateCopy.ClientAPIUser = UserName;
        stateCopy.ClientAPIPass = Pass;
        stateCopy.CompanyCode = CompanyCode;
        stateCopy.Division = Division;
        this.setState(stateCopy);
    }

    handleApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = value;
        this.setState(stateCopy);    
    }
    handleApiPass(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIPass = value;
        this.setState(stateCopy);    
    }
    handleClientApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ClientAPIUser = value;
        this.setState(stateCopy);    
    }
    handleClientApiPass(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ClientAPIPass = value;
        this.setState(stateCopy);    
    }
    handleCompanyCode(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.CompanyCode = value;
        this.setState(stateCopy);    
    }
    handleDivision(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Division = value;
        this.setState(stateCopy);    
    }

    ValidateSaveViventium(){

        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var Company = this.state.CompanyCode;

        if(UserName === null || UserName === "" || UserName === undefined)
        {
            toast.error("Client API User field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Pass === null || Pass === "" || Pass === undefined)
        {
            toast.error("Client API Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Company === null || Company === "" || Company === undefined)
        {
            toast.error("Company Code field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        return true;

    }
    SaveViventium(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var UserName = this.state.ClientAPIUser;
        var Pass = this.state.ClientAPIPass;
        var EasyUserName = this.state.APIUser;
        var EasyPass = this.state.APIPass;
        var Division = this.state.Division;
        var CompanyCode = this.state.CompanyCode;
        var CompanyCode1 = this.props.CompanyCode;

        var ViventiumList = this.props.DataVivemtium;
        var viventium = ViventiumList.find(x=> x.ALIAS === this.state.APIName);   

        var Validate = this.ValidateSaveViventium();
        if(Validate === false)
        {
            return false;
        }        
        this.setState({
            loadingViventium: true
        });
        var result = APIService.SaveViventiumSetting(CompanyCode1, email, UserName, Pass, EasyUserName, EasyPass, CompanyCode, Division);
        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingViventium: false
                });
                var newList = {
                    ALIAS: viventium.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    DIVISION: Division,
                    ID: viventium.ID,
                    NAME: viventium.NAME,
                    VALUE: {
                        UserName: UserName,
                        Password: Pass,
                        EasyApiUser: EasyUserName,
                        EasyApiPassword: EasyPass,
                        CompanyCode: CompanyCode +"-"+ Division,
                        Name:viventium.ALIAS
                    }
                };
                that.props.SetObject(newList);
                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingViventium: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingViventium: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {

            that.setState({
                loadingViventium: false,
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }   
    render(){     
        
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        
        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2">
                                    <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Easy API User</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="apiuser" id="apiuser" type="text" onChange={this.handleApiUser } value={ this.state.APIUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Easy API Password</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="apipass" id="apipass" type={this.state.type}  onChange={this.handleApiPass } value={ this.state.APIPass}/>
                            </div>   
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                        
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API User(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="clientapiuser" id="clientapiuser" type="text" onChange={this.handleClientApiUser}  value={ this.state.ClientAPIUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="clientapipass" id="clientapipass" type={this.state.APIPasswordType}  onChange={this.handleClientApiPass }   value={ this.state.ClientAPIPass}/>
                            </div>       
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHideAPIPasswordType}>{this.state.APIPasswordType === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                     
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Company Code(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="companycode" id="companycode" type="text" onChange={this.handleCompanyCode } value={ this.state.CompanyCode}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Division</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="division" id="division" type="text" onChange={this.handleDivision }  value={ this.state.Division}/>
                            </div>                          
                       </div>
                       <div className="row">             
                            <div className="col-2 offset-10" style={{ 'paddingTop': '200px'}} size="sm">
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingViventium}
                                />
                                {
                                    this.state.loadingViventium
                                    ?
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveViventium(e)} disabled>Save</Button>
                                    : 
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveViventium(e)}>Save</Button>
                                }
                               
                            </div>                             
                       </div>
                   </div>
                </div>
            </div>            
        );
    }
}

export default Viventium;


// WEBPACK FOOTER //
// ./src/APIComponent/Viventium.jsx